import systemModeApi from 'session-plugin/lib/utils/webapi/systemMode'
import systemModeTable from '@/meta/systemModeTable'
import { toPromise } from '../utils/helper'

export const state = {
  systemMode: null,
  dueDatePriv: null,
  dueDatePub: null,
  examDate: null,
  minimumMathGrade: null,
  minimumScienceGrade: null,
  minimumAgeLimit: null,
  maximumAgeLimit: null,
  maximumStudents: null,
  ...systemModeTable.reduce((prev, item) => {
    prev[`can${item.id}`] = false
    return prev
  }, {})
}

export const mutations = {
  setSystemMode (state, payload) {
    for (const [key, value] of Object.entries(payload)) {
      state[key] = value
    }
  },
  setSystemModeMeta (state) {
    systemModeTable.forEach(item => {
      state[`can${item.id}`] = item[state.systemMode]
    })
  }
}

export const getters = {
  getSystemModeDate: state => ({ dueDatePub: state.dueDatePub, dueDatePriv: state.dueDatePriv, examDate: state.examDate }),
  getAllSystemMode: state => state,
  getSystemModeMeta: state => Object.keys(state).reduce((prev, item) => {
    item.includes('can') && (prev[item] = state[item])
    return prev
  }, {})
}

export const actions = {
    async initSystemMode ({ commit }) {
        return await toPromise(async () => {
          const smResp = await systemModeApi.get()
          const smJson = await smResp.json()
          commit('setSystemMode', smJson)
          commit('setSystemModeMeta')
          return smResp
        })
      },
    async initDueDates ({ commit }) {
        return await toPromise(async () => {
            const datesResp = await systemModeApi.getDates()
            const datesJson = await datesResp.json()
            commit('setSystemMode', datesJson)
            commit('setSystemModeMeta')
            return datesResp
        })
    }
}

export default {
  state,
  mutations,
  getters,
  actions
}
